import { all, call, put, takeEvery } from 'redux-saga/effects'
import { getScopes } from 'services/apiKYE'
import { AuthStates, decodeToken, getUserTokenStateFromDecoded, Scopes } from 'utils/authUtils'
import { setScopeOptions, SUCCESS_LOGIN } from './auth/actions'

function* fetchScopeOptions(action) {
  const token = action.payload?.access_token
  const decodedToken = decodeToken(token)
  if (!decodedToken || getUserTokenStateFromDecoded(decodedToken, [Scopes.GET_SCOPES]) !== AuthStates.AUTHORIZED) {
    return
  }

  const response = yield call(getScopes, token)
  const scopeOptions = Array.isArray(response)
    ? [...response].sort((first, second) => (
      first.group.localeCompare(second.group) || first.description.localeCompare(second.description)
    ))
    : []
  yield put(setScopeOptions(scopeOptions))
}

export default function* rootSaga(_getState) {
  yield all([takeEvery(SUCCESS_LOGIN, fetchScopeOptions)])
}
